/* BRV-110 — Floating WhatsApp bubble.
   Trigger: configurable delay (default 8s) of inactivity (no scroll/tap).
   Show: 1× per session via sessionStorage. Respects prefers-reduced-motion.
   GA4: dispatches wa_float_view on show, wa_float_click on tap (BRV-113.e).
*/
(function(){
  var el = document.querySelector('[data-wa-float]');
  if (!el) return;
  if (sessionStorage.getItem('brava_wa_shown') === '1') return;

  var delay = parseInt(el.dataset.delay || '8', 10) * 1000;
  var surface = el.dataset.surface || 'pdp';
  var itemId = el.dataset.itemId || '';
  var timer = null;
  var armed = true;

  function show(){
    if (!armed) return;
    el.hidden = false;
    // Force reflow to enable transition
    el.offsetHeight;
    el.classList.add('is-visible');
    sessionStorage.setItem('brava_wa_shown', '1');
    armed = false;
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'wa_float_view',
        surface: surface,
        item_id: itemId,
        seconds_to_show: delay / 1000
      });
    }
  }

  function reset(){
    if (!armed) return;
    if (timer) clearTimeout(timer);
    timer = setTimeout(show, delay);
  }

  ['scroll', 'touchstart', 'mousemove', 'keydown'].forEach(function(evt){
    window.addEventListener(evt, reset, { passive: true });
  });

  reset();

  var link = el.querySelector('a.wa-float__btn');
  if (link) {
    link.addEventListener('click', function(){
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'wa_float_click',
          surface: surface,
          item_id: itemId
        });
      }
    });
  }

  var closeBtn = el.querySelector('[data-wa-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(){
      el.classList.remove('is-visible');
      setTimeout(function(){ el.hidden = true; }, 220);
      armed = false;
      if (timer) clearTimeout(timer);
    });
  }
})();
